import { createSelector } from '@reduxjs/toolkit';

import { selector } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/constants';
import { updateWorkflowSchemaInquiryFields } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/utils';
import { InquiryTemplate } from 'dashboard/models/inquiry-template';
import { Template } from 'dashboard/models/template';
import { WorkflowSchema } from 'dashboard/models/workflow';
import { RootState } from 'dashboard/redux/store';
import { FieldSchema } from 'lib/fields';

const getWorkflowSchema = (state: RootState): WorkflowSchema => state.workflowSchema;

// live updated field schema in FLE form
const getFormFieldSchema = (state: RootState): FieldSchema[] =>
  selector(state, 'field-schema') ?? [];

// current inquiry template
const getInquiryTemplate = (state: RootState): InquiryTemplate | Template =>
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  state.inquiryTemplate.inquiryTemplate;

/**
 * Cached selector which overwrites fetched workflow schema
 * fields with the current FLE field schema
 */
export const getWorkflowSchemaLiveUpdated = createSelector(
  [getWorkflowSchema, getFormFieldSchema, getInquiryTemplate],
  (workflowSchema, fieldSchema, inquiryTemplate): WorkflowSchema =>
    updateWorkflowSchemaInquiryFields(workflowSchema, fieldSchema, inquiryTemplate?.id),
);
